  import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { Portal } from '@fluentui/react-portal';
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of DatePicker
 */ export const renderDatePicker_unstable = (state)=>{
    assertSlots(state);
    const { inlinePopup } = state;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(state.root, {}),
            state.popupSurface && (inlinePopup ? /*#__PURE__*/ _jsx(state.popupSurface, {
                children: /*#__PURE__*/ _jsx(state.calendar, {})
            }) : /*#__PURE__*/ _jsx(Portal, {
                mountNode: state.mountNode,
                children: /*#__PURE__*/ _jsx(state.popupSurface, {
                    children: /*#__PURE__*/ _jsx(state.calendar, {})
                })
            }))
        ]
    });
};
